import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';

export type FaqPageProps = {};

const FaqPage: React.FC<FaqPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/faqheader.png'}
        heading={
          intl.formatMessage({
            id: 'faq'
          })
        } 
       />
       <div className="content">
        <div className="w-full flex flex-col bg-gray-100 rounded-xl overflow-hidden h-[500px] mb-6">
          <div className="flex items-center justify-start px-6 w-full bg-main h-12">
            <h2 className="text-white font-bold">
              {
                intl.formatMessage({
                  id: 'virt-assist'
                })
              }
            </h2>
          </div>
          <div id="chatarea" className="w-full flex flex-col h-full border-b-2 overflow-y-auto">
            <iframe src='https://interfaces.zapier.com/embed/chatbot/clvk77vkv0012gt34zwbqiy6p' height='600px' width='100%' allow='clipboard-write *' title='Virtual Assistant Chatbot'></iframe>
          </div>
          
        </div>
        
        <div className="w-full">
          <img src="/icons/faq-footer.svg" alt="" />
        </div>
       </div> 
    </div>
  );
}

export default FaqPage;